"use client";

import { useState } from "react";

export default function BusinessDetailsStep() {
    const [taxType, setTaxType] = useState("gst");
    const [selected, setSelected] = useState("gst");

    const [formData, setFormData] = useState({
        gst_number: "",
        gst_image: "https://example.com/images/gst.jpg",
        pan_number: "",
        pan_image: "https://example.com/images/pan.jpg",
        bussiness_type: "",
        company_name: "",
        logo: "https://example.com/images/gst.jpg",
        short_description: "",
        description: "",
        user_name: "",
        city: "",
        street: "",
        area_code: "",
        state: "",
        city_code: "",
        locality: "",
        latitude: "",
        longitude: "",
        country: "India"
    });

    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTQsImNvbnRhY3Rfbm8iOiI5MTM2MjYzNTU1IiwiaXNfbmV3X3VzZXIiOnRydWUsImlzcyI6InlvdXItYXBwLW5hbWUiLCJzdWIiOiIxNCIsImp0aSI6IjQ5MjNiNzc1LWI3OTgtNDI3OC05NWFiLTM3YjVmMmMyNGY3MCIsIm5iZiI6MTc3NDk2MTY2OTA1MiwiaWF0IjoxNzc0OTYxNjY5LCJleHAiOjE3NzUxMzQ0Njl9.33H7gGtQ8ZqVbUfT1vR2nKNUbvLbqsekFiQdp6zsQEQ"
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    };

    const handleSubmit = async () => {
        try {
            const payload =
                taxType === "gst"
                    ? {
                        ...formData,
                        pan_number: "",
                        pan_image: ""
                    }
                    : {
                        ...formData,
                        gst_number: "",
                        gst_image: ""
                    };

            const response = await fetch(
                "http://127.0.0.1:8000/api/seller-bussiness-info",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify(payload)
                }
            );

            const data = await response.json();

            if (response.ok) {
                alert("Business Info Submitted");
                console.log(data);
            } else {
                console.log("Error:", data);
            }
        } catch (error) {
            console.log("API Error:", error);
        }
    };

    return (
        <div className="">
            <h2 className="h4 fw-semibold text-dark mb-0 px-0 py-4">
                Business Information
            </h2>

            <div className="border shadow-sm" style={{ borderRadius: "14px" }}>

                {/* ================= Tax Information ================= */}
                <div className="border-0 mt-4">
                    <div className="card-body p-4 pt-0">

                        <div className="d-flex gap-3 mb-3" style={{ gap: "18px" }}>

                            <div
                                className={`px-2 py-1 border rounded d-flex align-items-center ${taxType === "gst" ? "border-warning bg-light active-card" : "border-secondary"}`}
                                onClick={() => setTaxType("gst")}
                                style={{ cursor: "pointer", width: "120px", gap: "8px" }}
                            >
                                <input type="radio" checked={taxType === "gst"} readOnly />
                                <span>GST</span>
                            </div>

                            <div
                                className={`px-2 py-1 border rounded d-flex align-items-center ${taxType === "nonGst" ? "border-warning bg-light active-card" : "border-secondary"}`}
                                onClick={() => setTaxType("nonGst")}
                                style={{ cursor: "pointer", width: "120px", gap: "8px" }}
                            >
                                <input type="radio" checked={taxType === "nonGst"} readOnly />
                                <span>Non-GST</span>
                            </div>

                        </div>

                        {/* GST */}
                        {taxType === "gst" && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">
                                        GST Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="gst_number"
                                        value={formData.gst_number}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter GST Number"
                                    />
                                </div>

                                <div>
                                    <label className="form-label">
                                        GST Certificate <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="file"
                                        name="gst_image"
                                        onChange={handleFileChange}
                                        className="form-control p-0"
                                    />
                                </div>
                            </>
                        )}

                        {/* NON GST */}
                        {taxType === "nonGst" && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">
                                        PAN Card Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="pan_number"
                                        value={formData.pan_number}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter PAN Card Number"
                                    />
                                </div>

                                <div>
                                    <label className="form-label">
                                        Upload PAN Card <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="file"
                                        name="pan_image"
                                        onChange={handleFileChange}
                                        className="form-control p-0"
                                    />
                                </div>
                            </>
                        )}

                    </div>

                    <div className="mx-4 my-0 border-bottom mt-2"></div>
                </div>

                {/* ================= Business Details ================= */}
                <div className="border-0">
                    <div className="card-body p-4">

                        <h5 className="mb-3 fw-semibold text-secondary">Business Details</h5>

                        <div className="d-flex" style={{ gap: "30px" }}>
                            <div className="w-50">
                                <label className="form-label">
                                    Business Type <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select p-2 w-100"
                                    name="bussiness_type"
                                    value={formData.bussiness_type}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Business Type</option>
                                    <option value="sole_proprietorship">Sole Proprietorship</option>
                                    <option value="partnership">Partnership</option>
                                    <option value="private_limited">Private Limited</option>
                                </select>
                            </div>

                            <div className="w-50">
                                <label className="form-label">
                                    Store Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="store_name"
                                    value={formData.store_name}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Your store display name"
                                />
                            </div>
                        </div>

                        <div className="d-flex mt-3" style={{ gap: "30px" }}>
                            <div className="w-50">
                                <label className="form-label">
                                    Company Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="company_name"
                                    value={formData.company_name}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="w-50">
                                <label className="form-label">
                                    Business Logo <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="file"
                                    name="logo"
                                    onChange={handleFileChange}
                                    className="form-control p-0"
                                />
                            </div>
                        </div>

                        {/* NEW FIELDS */}
                        <div className="d-flex mt-3" style={{ gap: "30px" }}>
                            <div className="w-50">
                                <label className="form-label">User Name</label>
                                <input
                                    type="text"
                                    name="user_name"
                                    value={formData.user_name}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="w-50">
                                <label className="form-label">Description</label>
                                <input
                                    type="text"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="mx-4 my-0 border-bottom mt-2"></div>

                {/* ================= Address ================= */}
                <div className="border-0">
                    <div className="card-body p-4">

                        <h5 className="mb-3 fw-semibold text-secondary">Business Address</h5>

                        <textarea
                            rows={3}
                            name="short_description"
                            value={formData.short_description}
                            onChange={handleChange}
                            className="form-control mb-3"
                            placeholder="Street address"
                        />

                        <div className="row g-3 mt-4">
                            <div className="col-md-6">
                                <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} className="form-control" placeholder="Pincode" />
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="city" value={formData.city} onChange={handleChange} className="form-control" placeholder="City" />
                            </div>
                        </div>

                        <div className="row mt-4 g-3">
                            <div className="col-md-6">
                                <input type="text" name="state" value={formData.state} onChange={handleChange} className="form-control" placeholder="State" />
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="country" value={formData.country} onChange={handleChange} className="form-control" />
                            </div>
                        </div>

                        <div className="row g-3 mt-4">
                            <div className="col-md-6">
                                <input type="text" name="street" value={formData.street} onChange={handleChange} className="form-control" placeholder="Street" />
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="locality" value={formData.locality} onChange={handleChange} className="form-control" placeholder="Locality" />
                            </div>
                        </div>

                        <div className="row g-3 mt-4">
                            <div className="col-md-6">
                                <input type="text" name="area_code" value={formData.area_code} onChange={handleChange} className="form-control" placeholder="Area Code" />
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="city_code" value={formData.city_code} onChange={handleChange} className="form-control" placeholder="City Code" />
                            </div>
                        </div>

                        <div className="row g-3 mt-4">
                            <div className="col-md-6">
                                <input type="text" name="latitude" value={formData.latitude} onChange={handleChange} className="form-control" placeholder="Latitude" />
                            </div>
                            <div className="col-md-6">
                                <input type="text" name="longitude" value={formData.longitude} onChange={handleChange} className="form-control" placeholder="Longitude" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button
                className="btn text-white shadow-none mt-4"
                style={{ background: "rgba(251, 130, 10, 1)" }}
                onClick={handleSubmit}
            >
                Submit
            </button>
        </div>
    );
}
